import direction from './direction'
import hotSpot from './hotSpot'
import system from './system'
import help from './help'

export default {
  direction,
  hotSpot,
  system,
  help
}



// WEBPACK FOOTER //
// ./src/views/ArticleNav/components/index.js